<template>
  <span>
    {{ cubicBezierNumber.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}
  </span>
</template>

<script setup lang="ts">
import { ref, onMounted, Ref, watch } from 'vue';
import { TransitionPresets, useTransition } from '@vueuse/core';
interface Props {
  cubicBezierNumber?: number;
  duration?: number;
}
const props = withDefaults(defineProps<Props>(), {
  cubicBezierNumber: 0,
  duration: 1000,
});
let duration: Ref<number> = ref(1000);
const baseNumber: Ref<number> = ref(0);
const cubicBezierNumber = useTransition(baseNumber, {
  duration,
  transition: TransitionPresets.easeInOutCubic,
});

onMounted(() => {
  baseNumber.value = props.cubicBezierNumber;
  duration.value = props.duration;
});

watch(
  () => props.cubicBezierNumber,
  () => {
    baseNumber.value = props.cubicBezierNumber;
    duration.value = props.duration;
  },
);
</script>
